module.exports = __webpack_public_path__ + "img/local_3_pack.1caad734.svg";